import { ABTest } from './ab_test.component';
import { Experiment } from './experiment.component';
import { Treatment } from './treatment.component';
export const ABTestingModule = angular.module('ABTestingModule', [])
    .component('abTest', ABTest)
    .component('experiment', Experiment)
    .component('treatment', Treatment)
    .name;
